export default __webpack_public_path__ + "static/media/DocDB.98c831c6.svg";